import {
    ChangeDetectorRef,
    Component,
    inject,
  } from '@angular/core';
  import { FormsModule } from '@angular/forms';
  
  import { IdentificationService } from '../../services/identification.service';
  
  @Component({
    selector: 'app-public-identification-form',
    standalone: true,
    imports: [FormsModule],
    templateUrl: './public-identification-form.html',
    styleUrl: './public-identification-form.scss',
  })
  export class PublicIdentificationForm {
    private identificationService = inject(
      IdentificationService,
    );
  
    private cdr = inject(ChangeDetectorRef);
  
    isSubmitting = false;
    submitted = false;
  
    linkerName = '';
    responsibleName = '';
    phone = '';
    species = 'DOG';
    animalName = '';
    plateDesign = '';
    material = 'STEEL';
    paymentProofUrl = '';
  
    submitForm(): void {
      if (
        !this.responsibleName ||
        !this.phone ||
        !this.species ||
        !this.animalName ||
        !this.material
      ) {
        return;
      }
  
      this.isSubmitting = true;
  
      const identification = {
        linkerName: this.linkerName,
        responsibleName: this.responsibleName,
        species: this.species,
        animalName: this.animalName,
        phone: this.phone,
        plateDesign: this.plateDesign,
        material: this.material,
        abaqCost: 0,
        providerCost: 0,
        paymentProofUrl: this.paymentProofUrl,
        status: 'PENDING',
      };
  
      this.identificationService
        .createIdentification(identification)
        .subscribe({
          next: () => {
            this.isSubmitting = false;
            this.submitted = true;
  
            this.cdr.detectChanges();
          },
  
          error: (error) => {
            console.error(
              '🔴 ERROR ENVIANDO FORMULARIO DE PLACA:',
              error,
            );
  
            this.isSubmitting = false;
  
            this.cdr.detectChanges();
          },
        });
    }
  }